export default __webpack_public_path__ + "static/109-min-min-e17a62dd167a1017321d35678657046b.jpg";